import { render, staticRenderFns } from "./AudioShow.vue?vue&type=template&id=c8f0b0a8&scoped=true&"
import script from "./AudioShow.vue?vue&type=script&lang=ts&"
export * from "./AudioShow.vue?vue&type=script&lang=ts&"
import style0 from "./AudioShow.vue?vue&type=style&index=0&id=c8f0b0a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f0b0a8",
  null
  
)

export default component.exports